import { FormControl, FormGroup } from '@angular/forms';

export function customMandatoryValidator(config: any, formGroup: FormGroup, control: FormControl) {

  if (this.checkVisibility(config, formGroup) && !control.value) {
      return { required: true };
  }
  return null;
}
